import { PropsWithChildren } from 'react'
import Styles from './ToastMessage.module.scss'

export const Details = ({ children }: PropsWithChildren) => <div className={Styles.details}>{children}</div>
